export const isInvalidNegotiatedVolume = (volume, statusId, naoNegociadoStatusId) => {
  const numericVolume = Number(volume);
  const allowsZero = naoNegociadoStatusId != null &&
    String(statusId) === String(naoNegociadoStatusId);

  return numericVolume < 0 || (numericVolume === 0 && !allowsZero);
};
